import { uniqueBy } from 'lib/array/arrayUtils'

type TicketParams = {
  time?: string
  isBuyNowBookLater?: boolean
  isGift?: boolean
}

export function useExperienceTicketsOptions(availableTimes: Array<App.ExperienceAvailabilityTimeSlot> | undefined, params: TicketParams) {
  const { isBuyNowBookLater, isGift, time } = params
  const allSlotsForTime = (availableTimes ?? []).filter(slot => isBuyNowBookLater || isGift || slot.time === time)
  const tickets = allSlotsForTime.flatMap(slot => slot.tickets)
  return uniqueBy(tickets, ticket => `${ticket.fareType}-${ticket.id}`)
}
